import { t } from 'i18next';
import { IPerformanceInvestmentPeriodsObject } from 'services/calculations/financialPerformance/types';

export const columns = [
  '',
  t('financialPlan.financialPerformance.investment.columns.columnNames.benchMarkValue'),
  t('financialPlan.financialPerformance.investment.columns.columnNames.projectedRatios'),
];

export const firstColumnValues = [
  'returnOnInvestment',
  'returnOnEquity',
  'returnOnAssets',
  'rateOfReturn',
  'netPresentValue',
  'paybackPeriod',
];

export const secondColumnValues = [
  'greaterThanTenPercent',
  'greaterThanFifteenPercent',
  'greaterThanFivePercent',
  'greaterThanTenPercentAgain',
  'npv',
  'lessThanSevenYears',
];

export const INVESTMENT_ROW_NAMES = {
  RETURN_ON_INVESTMENT: 'returnOnInvestment',
  RETURN_ON_EQUITY: 'returnOnEquity',
  RETURN_ON_ASSETS: 'returnOnAssets',
  RATE_OF_RETURN: 'rateOfReturn',
  NET_PRESENT_VALUE: 'netPresentValue',
  PAYBACK_PERIOD: 'paybackPeriod',
} as const;

export const INVESTMENT_FORM_NAMES = {
  INVESTMENT_CURRENCY: 'investmentCurrency',
  INVESTMENT_TABLE: 'investmentTable',
  INVESTMENT_FORECASTED_RESULT: 'investmentForecastedResult',
  DISCOUNT_RATE: 'discountRate',
} as const;

const initialPerfomanceObject: IPerformanceInvestmentPeriodsObject = {
  y1: 0,
  y3: 0,
  y5: 0,
};

export interface IInvestmentValuesType {
  [INVESTMENT_FORM_NAMES.INVESTMENT_TABLE]: {
    [INVESTMENT_ROW_NAMES.RETURN_ON_INVESTMENT]: IPerformanceInvestmentPeriodsObject;
    [INVESTMENT_ROW_NAMES.RETURN_ON_EQUITY]: IPerformanceInvestmentPeriodsObject;
    [INVESTMENT_ROW_NAMES.RETURN_ON_ASSETS]: IPerformanceInvestmentPeriodsObject;
    [INVESTMENT_ROW_NAMES.RATE_OF_RETURN]: IPerformanceInvestmentPeriodsObject;
    [INVESTMENT_ROW_NAMES.NET_PRESENT_VALUE]: IPerformanceInvestmentPeriodsObject;
    [INVESTMENT_ROW_NAMES.PAYBACK_PERIOD]: number;
  };
  [INVESTMENT_FORM_NAMES.INVESTMENT_FORECASTED_RESULT]: string;
  [INVESTMENT_FORM_NAMES.DISCOUNT_RATE]: number;
}

export const defaultInvestmentFieldValue = {
  [INVESTMENT_ROW_NAMES.RETURN_ON_INVESTMENT]: initialPerfomanceObject,
  [INVESTMENT_ROW_NAMES.RETURN_ON_EQUITY]: initialPerfomanceObject,
  [INVESTMENT_ROW_NAMES.RETURN_ON_ASSETS]: initialPerfomanceObject,
  [INVESTMENT_ROW_NAMES.RATE_OF_RETURN]: initialPerfomanceObject,
  [INVESTMENT_ROW_NAMES.NET_PRESENT_VALUE]: initialPerfomanceObject,
  [INVESTMENT_ROW_NAMES.PAYBACK_PERIOD]: 0,
};

export const investmentInitialValues = {
  [INVESTMENT_FORM_NAMES.INVESTMENT_TABLE]: defaultInvestmentFieldValue,
  [INVESTMENT_FORM_NAMES.INVESTMENT_FORECASTED_RESULT]: '',
  [INVESTMENT_FORM_NAMES.DISCOUNT_RATE]: 15,
};
